import {
  GET_ADDITIONAL_CUSTOMER,
  GET_ADDITIONAL_CUSTOMER_FAILED,
  GET_ADDITIONAL_CUSTOMER_SUCCESS,
} from './types';

const initialState = {};

const additionalCustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDITIONAL_CUSTOMER:
      return {
        ...state,
        [action.payload.customerId]: {
          id: action.payload.customerId,
          loaded: false,
          loading: true,
        },
      };
    case GET_ADDITIONAL_CUSTOMER_SUCCESS:
      return {
        ...state,
        [action.payload.customer.id]: {
          ...action.payload.customer,
          loaded: true,
          loading: false,
        },
      };
    case GET_ADDITIONAL_CUSTOMER_FAILED:
      return {
        ...state,
        [action.payload.customerId]: {
          id: action.payload.customerId,
          loaded: true,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default additionalCustomerReducer;
